<template>
    <div class="alert-global"
    :style="{
        background: colors.theme == 'dark' ? `#23272c` : `#23272c`,
        color: colors.theme == 'dark' ? `#fff` : `#fff`,
    }"    
    >
        <div class="image-alert"
        :style="{
            background: imageSrc == 'warning' ? `transparent` : '',
        }"      
        >
            <img v-if="imageSrc == 'warning'" :src="image" alt="" class="image">
            <ExpiredSessions v-if="imageSrc == 'error'"></ExpiredSessions>
        </div>
        <div class="title-alert"
        :style="{
            color: colors.theme == 'dark' ? `#000` : `#fff`,
        }"    
        >
            <div class="title">{{title}}</div>
            <div class="subtitle">{{subtitle}}</div>
        </div>
        <div class="button-alert"
             @click="closeAlert()">
            <button-simple
                :textButton='$t("components.Alerts.AlertGlobal.textButton")'></button-simple>
        </div>
    </div>
</template>
<script>
import ButtonSimple from '../Buttons/ButtonSimple'
import Bus from '../../main.js'
import ExpiredSessions from '../Shared/CustomIcons/Alert/ExpiredSessions.vue'
export default {
    components : {
        ButtonSimple,
        ExpiredSessions
    },
    props: {
        imageSrc : {
            type : String,
            required : true
        },
        title : {
            type : String,
            required : true
        },
        subtitle : {
            type : String,
            required : true
        },
        route : {
            type : String
        }
    },
    data(){
        return{
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    computed: {
        image(){
            return require(`../../assets/${this.imageSrc}.png`)
        }
    },
    methods: {
        closeAlert(){
            Bus.$emit('closeAlertGlobal')
            this.route ? this.$router.push(`/${this.route}`) : ''
        }
    }
}
</script>
<style lang="scss" scoped>
    .alert-global{

        z-index: 10000;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        // background-color: #2f353a;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .image-alert{

                width: 210px;
                background-color: #fff;
                padding: 50px 30px;
                border-radius: 200px;
            .image{
                height: 150px;
            }
        }

        .title-alert{
            
            text-align: center;
            // color: white;

            .title{

                font-weight: 900;
                text-transform: uppercase;
                font-size: 50px;
                letter-spacing: 1px;
                margin: 20px auto 0;
                width: 70%;
                position: relative;
                line-height: 43px;
                top: -45px;
            }

            .subtitle{
                width: 80%;
                margin: 0 auto 32px;
                font-weight: 700;
                font-size: 19px;

            }
        }

        .button-alert{
            width: 50%;
        }
    }
</style>
